(function () {
  var loader = document.getElementById('luxury-loader');
  if (!loader) return;
  function hide() {
    loader.classList.add('is-hidden');
    setTimeout(function () { loader.style.display = 'none'; }, 400);
  }
  var timer = setTimeout(hide, 1200);
  document.addEventListener('DOMContentLoaded', function() {
    clearTimeout(timer);
    setTimeout(hide, 600);
  });
})();
